import { render, staticRenderFns } from "./PostingCard.vue?vue&type=template&id=0054521a&scoped=true&"
import script from "./PostingCard.vue?vue&type=script&lang=js&"
export * from "./PostingCard.vue?vue&type=script&lang=js&"
import style0 from "./PostingCard.vue?vue&type=style&index=0&id=0054521a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054521a",
  null
  
)

export default component.exports